import React from 'react';
import { Col } from '../../../../grid';
import ReadMore from '../../../../ReadMore';

const RenderIndhold = ({
  indhold,
}) => {
  if (indhold) {
    return (
      <Col xs={12}>
        <ReadMore padding="15px" title="Vis nærings- &amp; vitaminindhold">{indhold()}</ReadMore>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderIndhold;
